import { Publisher } from '../../../types/publisher';
import { Advertiser } from '../../../types/advertiser';
import { Agency } from '../../../types/agency';
import { Token } from './token';
import {AdNetwork} from "../../../types/ad-network";

export enum UserStatus {
    ENABLED = 1,
    DISABLED = 0,
}
export enum UserRole {
    ROLE_SUPER_ADMIN = 'Super Admin',
    ROLE_ADVERTISER_ADMIN = 'Anunciante Admin',
    ROLE_AGENCY_ADMIN = 'Agência Admin',
    ROLE_PUBLISHER_ADMIN = 'Publisher Admin',
    ROLE_AD_NETWORK_ADMIN = 'Ad Network Admin',
}

export interface User {
    id: number;
    name: string;
    email: string;
    phone: string;
    birthday: string | null;
    jobTitle: string | null;
    role: UserRole;
    password: string | null;
    resetPasswordToken: string | null;
    resetPasswordTokenDateExpiration: Date | null;
    publisher: Publisher | null;
    agency: Agency | null;
    adNetwork: AdNetwork | null;
    advertiser: Advertiser | null;
    status: UserStatus;
    tokens: Token[];
    createdAt: Date;
    updatedAt: Date | null;
}

export type AddUser = Omit<User, 'id' | 'createdAt' | 'updatedAt' | 'tokens'>;